
import { useNavigate } from "react-router-dom";

// Utilitaire qui redirige vers /settings avec le hash d'onglet souhaité (ex: #messages)
export function useNavigateToSettingsTab(tab: string = "messages") {
  const navigate = useNavigate();
  return () => {
    navigate(`/settings#${tab}`);
    // Un mini scroll ou équivalent UX peut être ajouté ici si besoin
  }
}
